import { render, staticRenderFns } from "./PrincipalBanner.vue?vue&type=template&id=342b8563"
import script from "./PrincipalBanner.vue?vue&type=script&lang=js"
export * from "./PrincipalBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports